import React from 'react';
import { Dropdown } from 'antd';
import useTranslation from '../../hooks/useTranslation';
import './LanguageSelector.css';

// Импорт изображений флагов
import englishGbFlag from '../../assets/flag/rounded/ENGLISH_GB.png';
import germanFlag from '../../assets/flag/rounded/GERMAN.png';
import spanishEsFlag from '../../assets/flag/rounded/SPANISH_ES.png';
import russianFlag from '../../assets/flag/rounded/RUSSIAN.png';
import chineseSimplifiedFlag from '../../assets/flag/rounded/CHINESE_SIMPLIFIED.png';
import italianFlag from '../../assets/flag/rounded/ITALIAN.png';
import polishFlag from '../../assets/flag/rounded/POLISH.png';
import frenchFlag from '../../assets/flag/rounded/FRENCH.png';

// Ключи — коды языка интерфейса; имена файлов флагов остались прежними,
// потому что те же картинки используются и для локалей колод
const languages = [
    { key: 'en-GB', label: 'English', icon: englishGbFlag },
    { key: 'ru-RU', label: 'Russian', icon: russianFlag },
    { key: 'es-ES', label: 'Spanish', icon: spanishEsFlag },
    { key: 'de-DE', label: 'German', icon: germanFlag },
    { key: 'fr-FR', label: 'French', icon: frenchFlag },
    { key: 'pl-PL', label: 'Polish', icon: polishFlag },
    { key: 'zh-CN', label: 'Chinese', icon: chineseSimplifiedFlag },
    { key: 'it-IT', label: 'Italian', icon: italianFlag },
];

export default function LanguageSelector() {
    const { currentLanguage, changeLanguage } = useTranslation();

    const handleMenuClick = (e) => {
        changeLanguage(e.key);
    };

    // Пункты данными: `overlay` и `Menu.Item` в antd v5 устарели. Класс обёртки
    // переезжает в overlayClassName — оформление выпадающего списка не меняется.
    const menuItems = languages.map((lang) => ({
        key: lang.key,
        icon: <img src={lang.icon} alt={lang.label} className="flag-image" />,
        label: lang.label,
    }));

    // Найти текущий язык для отображения флага
    const currentLanguageIcon =
        languages.find((lang) => lang.key === currentLanguage)?.icon || englishGbFlag;

    return (
        <Dropdown
            menu={{ items: menuItems, onClick: handleMenuClick, selectedKeys: [currentLanguage] }}
            overlayClassName="drawerMenu"
            trigger={['click']}
            placement="bottomRight"
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                }}
                className="language-selector"
            >
                <img
                    src={currentLanguageIcon}
                    alt="Current Language"
                    className="flag-image current-flag"
                />
            </div>
        </Dropdown>
    );
}
